export default ":host ::ng-deep .tooltip {\n  white-space: nowrap;\n}"